import React from 'react';
import cx from 'classnames';

import { Label } from '@atlas/ui';

import { DAY, HOUR, MIN, SECOND } from 'common/constants';
import crownIcon from 'static/assets/icons/casino/crown.svg';
import cupIcon from 'static/assets/icons/casino/cup.svg';
import leaderboardIcon from 'static/assets/icons/casino/leaderboard.svg';
import starsIcon from 'static/assets/icons/casino/stars.svg';

const statusMap = {
  is_cancelled: {
    status: 'smartico_tournaments_status_cancelled',
    timer: 'smartico_tournaments_timer_cancelled',
  },
  is_finished: {
    status: 'smartico_tournaments_status_finished',
    timer: 'smartico_tournaments_timer_finished',
  },
  is_in_progress: {
    status: 'smartico_tournaments_status_started',
    timer: 'smartico_tournaments_timer_finishing_in',
  },
  is_upcoming: {
    status: 'smartico_tournaments_status_gathering',
    timer: 'smartico_tournaments_timer_starts_in',
  },
};

export const getStatusConfig = tournament => {
  if (!tournament) return '';
  const key = Object.keys(statusMap).find(k => tournament[k]);
  return key ? statusMap[key] : '';
};

const isAutoRegistrationUsersTournament = tournament =>
  tournament.registration_type === 'AUTO' && (tournament.is_upcoming || tournament.is_in_progress);

export const isTournamentSuitable = (tournament, key) =>
  Array.isArray(key) ? key.some(a => tournament[a]) : !!tournament[key];

export const getTournamentBtnLabel = tournament => {
  if (tournament.is_user_registered || isAutoRegistrationUsersTournament(tournament)) {
    return 'smartico_tournaments_btn_join_registered';
  }

  if (tournament.is_can_register) {
    return 'smartico_tournaments_btn_join_free';
  }

  return 'smartico_tournaments_btn_registration_closed';
};

export const formatDate = time => {
  const date = new Date(time);
  return date.toLocaleDateString('en-GB', { day: '2-digit', month: 'long' });
};

export const getBuyInText = tournament => {
  if (!tournament) return [];

  if (tournament.registration_cost_points) {
    return [tournament.registration_cost_points, 'smartico_tournaments_buy_in_points'];
  }

  if (tournament.registration_cost_gems) {
    return [tournament.registration_cost_gems, 'smartico_tournaments_buy_in_gems'];
  }

  if (tournament.registration_cost_diamonds) {
    return [tournament.registration_cost_diamonds, 'smartico_tournaments_buy_in_diamonds'];
  }

  return [null, 'smartico_tournaments_buy_in_free'];
};

export const calculateTimeLeft = targetTime => {
  const now = new Date().getTime();
  const timeDiff = targetTime - now;

  if (timeDiff > 0) {
    const days = Math.floor(timeDiff / DAY);
    const hours = Math.floor((timeDiff % DAY) / HOUR);
    const minutes = Math.floor((timeDiff % HOUR) / MIN);
    const seconds = Math.floor((timeDiff % MIN) / SECOND);
    return { days, hours, minutes, seconds };
  } else {
    return { days: 0, hours: 0, minutes: 0, seconds: 0 };
  }
};

export { crownIcon, cupIcon, leaderboardIcon, starsIcon };

export const TabsList = ({ categoryId, onClick, tabs }) => {
  if (!tabs || tabs.length < 2) {
    return null;
  }

  return (
    <div className="smartico-tournaments-tabs">
      {tabs.map((i, index) => {
        return (
          <div
            className={cx('smartico-tournaments-tab', {
              'smartico-tournaments-tab-active': i.text === categoryId,
            })}
            key={i.text}
            onClick={() => onClick({ index, key: i.key, text: i.text })}
          >
            <Label
              className="smartico-tournaments-tab-text"
              message={`smartico_tournaments_tab_${i.text}`}
            />
            {!!i.count && <span className="smartico-tournaments-tab-text">{`(${i.count})`}</span>}
          </div>
        );
      })}
    </div>
  );
};

export const PRIZES_PER_PAGE = 10;
export const PLAYERS_PER_PAGE = 10;
